import { useSelector } from 'react-redux';

const mapState = (state: Store.State) => state.user.permissions ?? [];

export function useUserPermissions() {
  return useSelector(mapState);
}